import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { GSP_COMPONENTS } from '../components';
import { ADPComponentsModule as ComponentsModule } from 'digital-core';
import { GspMaterialModule } from './gsp-material.module';
import { GspSharedModule } from './gsp-shared.module'
import { GoogleMapsModule } from '@angular/google-maps';
import { GspDirectivesModule } from './gsp-directives.module';

@NgModule({
    declarations: [...GSP_COMPONENTS],
    imports: [
        CommonModule,
        GspSharedModule,
        ComponentsModule,
        RouterModule,
        GspMaterialModule,
        GoogleMapsModule,
        GspDirectivesModule
    ],
    exports: [...GSP_COMPONENTS],
   
})
export class GspComponentsModule { }
